
































































import { Component, Vue, Prop } from "vue-property-decorator";

@Component
export default class ChecklistRekapStep extends Vue {
  @Prop({ default: null }) session!: any;
}
